import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageKey, StorageService } from '@services/storage.service';
import { APP_PATHS } from '@/app/utils';

/** True when a real study id is stored (not empty / "null"). */
function hasSelectedStudy(storage: StorageService): boolean {
  const studyId = storage.getValue(StorageKey.uniqueStudyId);
  return !!studyId && studyId !== 'null';
}

/**
 * Blocks authenticated app routes until a study is selected.
 * Exempt routes (study list / add-edit-study) should not use this guard.
 */
export const StudyGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const router = inject(Router);

  if (hasSelectedStudy(storage)) {
    return true;
  }

  return router.createUrlTree([APP_PATHS.STUDY]);
};
